import type { VisualizationPreset } from '../VisualizerMapView';

export type BuiltInFindVisualizationId =
  | 'defaultMaterial'
  | 'defaultTimeGradient';

export type FindVisualization =
  | {
      id: BuiltInFindVisualizationId;
      kind: 'built-in';
    }
  | {
      id: string;
      kind: 'preset';
      preset: VisualizationPreset;
    };

export const DEFAULT_FIND_VISUALIZATION: FindVisualization = {
  id: 'defaultMaterial',
  kind: 'built-in',
};
